import { useLocation } from "react-router-dom";

import useDoctorNotifications from "../../hooks/useDoctorNotifications";
import { ROUTES } from "../../routes";
import NotificationEntryBanner from "./NotificationEntryBanner";
import NotificationS4Notifier from "./NotificationS4Notifier";
import NotificationsDock from "./NotificationsDock";

import "./doctor-notifications.css";

/** Публичные и auth-страницы без глобального dock/banner */
const HIDDEN_PATH_PREFIXES = [
    ROUTES.AUTH,
    ROUTES.AUTH_CODE,
    ROUTES.AUTH_SMS_VERIFY,
    ROUTES.OAUTH_CALLBACK,
];

function isHiddenRoute(pathname) {
    return HIDDEN_PATH_PREFIXES.some(
        (p) => pathname === p || pathname.startsWith(`${p}/`)
    );
}

/**
 * Глобальная оболочка: баннер новых уведомлений + постоянный dock для врача.
 */
export default function DoctorNotificationsShell() {
    const { pathname } = useLocation();
    const { enabled } = useDoctorNotifications();

    if (!enabled || isHiddenRoute(pathname)) return null;

    return (
        <>
            <NotificationEntryBanner />
            <NotificationS4Notifier />
            <NotificationsDock />
        </>
    );
}
